import {
  createViz
} from 'dataviz/rendering/base';

import {
  formatForMapDataViz
} from 'util/formatters/data-viz/map';

import appendVizMap from './appendVizMap';

const renderVizMap = ({ config, zones }) => {
  return ({ element, selector }) => {
    const mapGeoJson = formatForMapDataViz(zones, config);
    let viz = createViz({ element, selector, config: config.baseConfig });
    return appendVizMap({ viz, mapGeoJson, config: config.mapConfig });
  };
};

export default renderVizMap;
